import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: {
			title: 'Alex - Home',
		},
	},
	{
		path: '/about',
		name: 'About',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ '../views/About.vue'),
		meta: {
			title: 'Alex - About',
		},
	},
	{
		path: '/projects',
		name: 'Projects',
		// route level code-splitting
		// this generates a separate chunk (projects.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "projects" */ '../views/Projects.vue'),
		meta: {
			title: 'Alex - Projects',
		},
	},
	{
		path: '/projects/mygameengine',
		name: 'Custom Game Engine',
		// route level code-splitting
		// this generates a separate chunk (projects.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "projects" */ '../views/CustomGameEngine.vue'
			),
		meta: {
			title: 'My Custom Game Engine',
		},
	},
	{
		path: '/projects/layoffproject',
		name: 'Project: LayOff ',
		// route level code-splitting
		// this generates a separate chunk (projects.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "projects" */ '../views/LayOffProject.vue'
			),
		meta: {
			title: 'LayOff - Online Game',
		},
	},
	{
		path: '/projects/layoffwebsite',
		name: 'LayOff Website',
		// route level code-splitting
		// this generates a separate chunk (projects.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "projects" */ '../views/LayOffWebsite.vue'
			),
		meta: {
			title: 'LayOff - Website',
		},
	},
	{
		path: '/projects/rogueprotocol',
		name: 'Project: Rogue Protocol',
		// route level code-splitting
		// this generates a separate chunk (projects.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "projects" */ '../views/RogueProtocol.vue'
			),
		meta: {
			title: 'Rogue Protocol - Singleplayer Game',
		},
	},
	{
		path: '/projects/stickdots',
		name: 'Project: StickDots',
		// route level code-splitting
		// this generates a separate chunk (projects.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "projects" */ '../views/StickDots.vue'
			),
		meta: {
			title: 'StickDots - Online Mobile Game',
		},
	},
	{
		path: '/projects/robodash',
		name: 'Project: RoboDash',
		// route level code-splitting
		// this generates a separate chunk (projects.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "projects" */ '../views/RoboDash.vue'
			),
		meta: {
			title: 'RoboDash - Single Player Game',
		},
	},
	{
		path: '/projects/cherub-online',
		name: 'Project: MMORPG',
		component: () =>
			import(
				/* webpackChunkName: "projects" */ '../views/CherubOnline.vue'
			),
		meta: {
			title: 'Cherub Online - MMO RPG',
		},
	},
	{
		path: '/contact',
		name: 'Contact',
		// route level code-splitting
		// this generates a separate chunk (projects.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "projects" */ '../views/Contact.vue'),
		meta: {
			title: 'Alex - Contact',
		},
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior(to, from, savedPosition) {
		return savedPosition || { top: 0 };
	},
});

export default router;

router.afterEach((to) => {
	document.title = to.meta.title || 'Alex Buzmion';
});
